// O painel lateral com a arte da opção de venda.
import React from "react";
import * as Styles from "../../styles/PointOfSale.styles";
import tableSvg from "../../../../assets/table.svg";
import counterSvg from "../../../../assets/counter.svg";
import deliverySvg from "../../../../assets/delivery.svg";

export const MenuLateral: React.FC<{
  component: any;
  componentProps: any;
  selectedSaleOption: any;
}> = ({
  component,
  componentProps,
  selectedSaleOption,
}) => {
  const {
    componentStatus,
    componentPosition,
    componentBrightness,
    componentWidth,
    componentHeight,
    componentBackgroundColor,
  } = componentProps;
  return (
    <Styles.RightMenu
      selected={Boolean(component.componentSelected)}
      id={String(component.componentId)}
      componentStatus={String(componentStatus)}
      componentPosition={componentPosition}
      componentBrightness={String(componentBrightness)}
      componentWidth={String(componentWidth)}
      componentHeight={String(componentHeight)}
      componentBackgroundColor={String(componentBackgroundColor)}
    >
      {component.componentSelected && (
        <Styles.SelectedIcon
          top={component.componentProps.componentPosition.y}
          left={component.componentProps.componentPosition.x}
        >
          zoom_out_map
        </Styles.SelectedIcon>
      )}
      <Styles.SaleOptionImg
        src={
          selectedSaleOption?.itemInfoValue.saleOptionImg ===
            "default"
            ? selectedSaleOption?.itemInfoValue.saleOptionType === "1"
              ? tableSvg
              : selectedSaleOption?.itemInfoValue.saleOptionType ===
                "2"
                ? counterSvg
                : deliverySvg
            : selectedSaleOption?.itemInfoValue.saleOptionImg
        }
        alt={selectedSaleOption?.itemInfoName}
      />
    </Styles.RightMenu>
  );
};
